import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

export default class extends Controller {
  static targets = [ 'area']
  
  toggle(event) {
    new bootstrap.Collapse(this.areaTarget)
    event.currentTarget.classList.toggle('fa-rotate-180')
  } 
}
